<template>
  <BreadCrumb PageTitle="Détails Bon Suivi livreur" />
  <PointageDetails />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import PointageDetails from "@/components/Notes/Pointage/PointageDetails.vue";

export default defineComponent({
  name: "PointageDetailsPage",
  components: {
    BreadCrumb,
    PointageDetails,
  },
});
</script>
